import { useModalMeta } from "@/shared/atoms/useModal";
import useFranchiseHook from "@/shared/hooks/useFranchiseHook";
import useUploadCloudinaryHook from "@/shared/hooks/useUploadCloudinaryHook";
import useWebsiteSettingsHook from "@/shared/hooks/useWebsiteSettingsHook";
import { errorToast, getFormData } from "@/shared/utils/helpers";
import { useTranslation } from "react-i18next";
import { ModalProps } from "../Modal/Modal";
import UploadImageWithLibraryModal from "./UploadImageWithLibraryModal";

const AboutUsImageModal = ({ onExit }: ModalProps) => {
  const { t } = useTranslation();
  const [{ onUpload }] = useModalMeta();
  const [franchiseId] = useFranchiseHook();
  const { postImageToCloudinary } = useWebsiteSettingsHook({ franchiseId });
  const uploadToCloudinary = useUploadCloudinaryHook();

  // Without the library only files are passed.
  const handleSave = async ([file]: (File | string)[]) => {
    if (!(file instanceof File)) return;
    try {
      const signData =
        await postImageToCloudinary.mutateAsync("about-us-image");
      if (!signData) throw new Error("Missing Cloudinary signature");

      const data = await uploadToCloudinary.mutateAsync({
        upload_url: signData.upload_url,
        res: getFormData(file, signData),
      });
      onUpload(data.secure_url);
    } catch (err) {
      errorToast("settings_page.aboutUsImageUploadFailed");
      throw err;
    }
  };

  return (
    <UploadImageWithLibraryModal
      onExit={onExit}
      onSave={handleSave}
      title={t("settings_page.aboutUsAddImage")}
      showLibrary={false}
    />
  );
};

export default AboutUsImageModal;
